export const markdownText = (brandingName?) => (
    '## Introduction\n' +
    '\n' +
    'This Telehealth Informed Consent ("Consent") explains the use of telehealth services provided through The Video Vets platform, operated by The Pet Parent Company LLC ("Company," "we," "our," or "us").\n' +
    '\n' +
    'Telehealth involves the use of electronic communications and technology to allow licensed veterinary professionals to provide consultations, guidance, and other veterinary-related services remotely when the veterinarian and pet are not physically located together.\n' +
    '\n' +
    'Providers participating on the Platform may include primary care veterinarians, specialists, and other licensed veterinary professionals.\n' +
    '\n' +
    'Telehealth communications may include:\n' +
    '\n' +
    '- Patient medical records\n' +
    '- Medical images and photographs\n' +
    '- Real-time messaging and chat\n' +
    '- Live two-way audio and video\n' +
    '- Diagnostic information and related files\n' +
    '\n' +
    'Electronic systems used by the Platform incorporate commercially reasonable security measures designed to protect the confidentiality and integrity of information transmitted through the Platform.\n' +
    '\n' +
    '## Company Information\n' +
    '\n' +
    '**Legal Entity:** The Pet Parent Company LLC  \n' +
    '**Trade Name:** The Video Vets  \n' +
    '**Principal Office:** 1621 Central Ave, Cheyenne, WY 82001\n' +
    '\n' +
    '## Expected Benefits\n' +
    '\n' +
    'Potential benefits of telehealth services may include:\n' +
    '\n' +
    '- Improved access to veterinary care\n' +
    '- Increased convenience and flexibility\n' +
    '- Faster consultations and follow-up care\n' +
    '- Access to specialists and remote expertise\n' +
    '- Reduced travel and wait times\n' +
    '\n' +
    '## Potential Risks\n' +
    '\n' +
    'As with any medical or telehealth service, there are potential risks associated with telehealth consultations. These may include, but are not limited to:\n' +
    '\n' +
    '- Information transmitted may not be sufficient for appropriate veterinary decision-making due to poor image quality, technical limitations, or incomplete information.\n' +
    '- Delays in evaluation or treatment due to technical failures, connectivity issues, or equipment malfunctions.\n' +
    '- In rare instances, security safeguards may fail and result in unauthorized access to information.\n' +
    '- Incomplete medical histories or records may result in judgment errors, allergic reactions, medication interactions, or incomplete recommendations.\n' +
    '- Telehealth services may not be appropriate for all conditions or emergencies.\n' +
    '\n' +
    'If your pet is experiencing a medical emergency, you should immediately contact an emergency veterinary clinic or your primary veterinarian.\n' +
    '\n' +
    '## Acknowledgements & Consent\n' +
    '\n' +
    'By signing or otherwise accepting this Consent, you acknowledge and agree to the following:\n' +
    '\n' +
    '### 1. Privacy & Confidentiality\n' +
    '\n' +
    'I understand that laws protecting the privacy and confidentiality of medical information may apply to telehealth communications and that commercially reasonable efforts will be made to protect my information.\n' +
    '\n' +
    '### 2. Voluntary Participation\n' +
    '\n' +
    'I understand that participation in telehealth services is voluntary and that I may withhold or withdraw consent at any time without affecting future care options.\n' +
    '\n' +
    '### 3. Access to Information\n' +
    '\n' +
    'I understand that I may request access to information obtained or recorded during telehealth interactions, subject to applicable law.\n' +
    '\n' +
    '### 4. Alternative Care Options\n' +
    '\n' +
    'I understand that alternative methods of veterinary care may be available, including in-person examinations and treatment.\n' +
    '\n' +
    'I acknowledge that telehealth services may not replace in-person veterinary care when physical examination, diagnostics, or emergency treatment are necessary.\n' +
    '\n' +
    '### 5. Interstate Communications\n' +
    '\n' +
    'I understand that telehealth communications may involve veterinary professionals located in different states or jurisdictions, subject to applicable licensing laws.\n' +
    '\n' +
    '### 6. Coordination with Primary Veterinarian\n' +
    '\n' +
    'I understand that it is my responsibility to share relevant telehealth information with my pet’s primary veterinarian when appropriate.\n' +
    '\n' +
    '### 7. No Guarantee of Outcome\n' +
    '\n' +
    'I understand that while telehealth services may provide benefits, no diagnosis, treatment outcome, or medical result can be guaranteed.\n' +
    '\n' +
    '### 8. Emergency Situations\n' +
    '\n' +
    'I understand that telehealth services are not intended for emergency veterinary situations.\n' +
    '\n' +
    'In emergency consultations, the veterinarian’s responsibility is limited to providing recommendations regarding next steps and emergency care.\n' +
    '\n' +
    '### 9. Veterinary-Client-Patient Relationship (VCPR)\n' +
    '\n' +
    'I understand that telehealth services may not establish a Veterinary-Client-Patient Relationship (VCPR) in all jurisdictions and that certain services, including prescriptions, may be limited by state law.\n' +
    '\n' +
    '## Client Consent to Telehealth Services\n' +
    '\n' +
    'I certify that:\n' +
    '\n' +
    '- I have read and understand this Telehealth Informed Consent.\n' +
    '- I have had the opportunity to ask questions.\n' +
    '- My questions have been answered to my satisfaction.\n' +
    '- I voluntarily consent to participate in telehealth services through The Video Vets platform.\n' +
    '- I authorize licensed veterinary professionals using The Video Vets platform to provide telehealth consultations regarding my pet’s care.\n'
);

